module.exports = __webpack_public_path__ + "static/img/home.8e9270a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home.jpg
// module id = mUNP
// module chunks = 1